// Video section - autoplay muted on scroll, fullscreen with sound on click
document.addEventListener('DOMContentLoaded', function() {
    var wrapper = document.querySelector('.video-wrapper');
    if (!wrapper) return;

    var poster = wrapper.querySelector('.video-poster');
    var playerWrap = wrapper.querySelector('.video-player');
    var videoFull = playerWrap ? playerWrap.querySelector('video') : null;
    var videoPreview = poster ? poster.querySelector('.video-preview') : null;
    var overlay = poster ? poster.querySelector('.video-overlay') : null;

    if (!poster || !videoPreview) return;

    var isAutoPlaying = false;

    // Автоплей без звука при появлении в viewport
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                if (!isAutoPlaying) {
                    videoPreview.muted = true;
                    videoPreview.play().catch(function() {});
                    isAutoPlaying = true;
                }
            } else {
                if (isAutoPlaying) {
                    videoPreview.pause();
                    isAutoPlaying = false;
                }
            }
        });
    }, { threshold: 0.3 });

    observer.observe(wrapper);

    // Клик по постеру — полноэкранный режим со звуком
    if (videoFull) {
        poster.addEventListener('click', function() {
            // Останавливаем превью
            videoPreview.pause();
            isAutoPlaying = false;

            // Показываем полный плеер
            poster.style.display = 'none';
            playerWrap.style.display = 'block';

            // Синхронизируем позицию
            videoFull.currentTime = videoPreview.currentTime;
            videoFull.muted = false;

            var playPromise = videoFull.play();
            if (playPromise !== undefined) {
                playPromise.then(function() {
                    requestFullscreen(videoFull);
                }).catch(function() {});
            }
        });

        // Выход из полноэкранного режима
        document.addEventListener('fullscreenchange', onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', onFullscreenChange);

        function onFullscreenChange() {
            var isFullscreen = document.fullscreenElement || document.webkitFullscreenElement;
            if (!isFullscreen && videoFull) {
                // Вернуть превью
                poster.style.display = '';
                playerWrap.style.display = 'none';

                // Синхронизируем позицию обратно в превью
                videoPreview.currentTime = videoFull.currentTime;
                videoFull.pause();

                // Если блок ещё виден — продолжить автоплей
                videoPreview.muted = true;
                videoPreview.play().catch(function() {});
                isAutoPlaying = true;
            }
        }

        // Видео закончилось — вернуть постер
        videoFull.addEventListener('ended', function() {
            exitFullscreen();
            poster.style.display = '';
            playerWrap.style.display = 'none';
            videoPreview.currentTime = 0;
            videoFull.currentTime = 0;
        });
    }

    function requestFullscreen(el) {
        if (el.requestFullscreen) {
            el.requestFullscreen();
        } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
        } else if (el.webkitEnterFullscreen) {
            el.webkitEnterFullscreen();
        }
    }

    function exitFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen().catch(function() {});
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }
});
